module.exports = __webpack_public_path__ + "img/logo.31fe9995.png";